export const ABCS_DATA_PARTNER_ID = 5;
export const ABCS_DATA_PARTNER_NAME = 'ABCS';
export const ACCRETIVE_DATA_PARTNER_ID = 6;
export const ACCRETIVE_DATA_PARTNER_NAME = 'Accretive';

export const RETARGETING_DATA_PARTNERS = Object.freeze([
  { name: 'StreetMetrics' },
  { name: 'GroundTruth' },
  { name: 'Liveramp Retargeting' },
  { name: 'Liveramp Measurement' },
  { name: ABCS_DATA_PARTNER_NAME, dataPartnerId: ABCS_DATA_PARTNER_ID },
  { name: ACCRETIVE_DATA_PARTNER_NAME, dataPartnerId: ACCRETIVE_DATA_PARTNER_ID },
  { name: 'Carvertise' },
  { name: 'Carvertise/Azira' },
  { name: 'Intersection' },
]);

export function normalizeDataPartnerIdentifier(value) {
  return String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
}

export function isAbcsDataPartner(partner) {
  if (!partner) {
    return false;
  }

  if (partner.dataPartnerId === ABCS_DATA_PARTNER_ID || partner.id === ABCS_DATA_PARTNER_ID) {
    return true;
  }

  return normalizeDataPartnerIdentifier(partner.name) === normalizeDataPartnerIdentifier(ABCS_DATA_PARTNER_NAME);
}

export function isAccretiveDataPartner(partner) {
  if (!partner) {
    return false;
  }

  if (partner.dataPartnerId === ACCRETIVE_DATA_PARTNER_ID || partner.id === ACCRETIVE_DATA_PARTNER_ID) {
    return true;
  }

  return normalizeDataPartnerIdentifier(partner.name) === normalizeDataPartnerIdentifier(ACCRETIVE_DATA_PARTNER_NAME);
}
